export default {
    maximumYear: {
        male: 1381,
        female: 1385,
        age: 80
    },
};